// ---------- INITIAL CALL ON PAGE LOAD ----------
document.addEventListener("DOMContentLoaded", () => {

  // const metalInput = document.querySelector('input[name="options[Metal Type]"]:checked');

  // if (metalInput) {
  //   // Create a fake event object (for update function)
  //   updateVideo();
  //   const fakeEvent = { target: metalInput };
  //   updateImagesByMetal(fakeEvent);  // initial image filtering
  // }

  // const letterInput = document.querySelector('input[name="options[Letter]"]:checked');


  // if (letterInput) {
  //   // Create a fake event object (for update function)
  //   updateVideo();
  //   const fakeEvent = { target: letterInput };
  //   updateImagesByMetal(fakeEvent);  // initial image filtering
  // }

  // setTimeout(() => {
  //     byor_image();
  // }, 2000);

  openPop();
  showVaraintOption();
  cleanProductDesciption();
  // selectInitialVariant();
});

document.querySelectorAll('.product-selector input[type="radio"]').forEach(input => {
  input.addEventListener('change', () => {
    setTimeout(openPop, 1500);
    // setTimeout(openPop, 2000);
  });
});

document.querySelectorAll('input[name="options[Metal Type]"], input[name="options[Letter]"]').forEach(input => {

  // setTimeout(() => {
  //         selectInitialVariant();
  // }, 1000);

  input.addEventListener('change', (e) => {
    // Fetch current selected variant if available
        // Get value from data-video attribute
        setTimeout(() => {
          // updateVideo(); 
          // changeSKU();
          // updateImagesByMetal(e);
        }, 1500);

  });

});

// Disable unaviable carat options
document.addEventListener("DOMContentLoaded", function () {

  const variants = JSON.parse(document.getElementById('ProductVariantJson').textContent);

  function getSelectedOptions() {
    return {
      option1: document.querySelector('input[name="options[Metal Type]"]:checked')?.value,
      option2: document.querySelector('input[name="options[Carat]"]:checked')?.value,
      option3: document.querySelector('input[name="options[Gemstone]"]:checked')?.value
    };
  }

  function setInputDisable(variantExists, input){
      if (!variantExists) {
        input.disabled = true;
      } else {
        input.disabled = false;
      }
  }

  function updateCaratAvailability() {
    const selectedMetal = getSelectedOptions().option1;
    const selectedGemstone = getSelectedOptions().option3;

    if(!selectedGemstone)
      return;

    document.querySelectorAll('input[name="options[Carat]"]').forEach(input => {

      const caratValue = input.value;

      const variantExists = variants.some(variant =>
        variant.option1 === selectedMetal &&
        variant.option2 === caratValue &&
        variant.option3 === selectedGemstone
      );

    setInputDisable(variantExists, input);
    setTimeout(()=>{
      setInputDisable(variantExists, input);
    }, 0)

    });
  }

  // Run on load
  updateCaratAvailability();

  // Run when Metal or Gemstone changes
  document.querySelectorAll('input[name="options[Metal Type]"], input[name="options[Gemstone]"], input[name="options[Carat]"]').forEach(input => {
    input.addEventListener('change', updateCaratAvailability);
  });

});

// open click poduim open 
document.addEventListener('click', function (e) {
  const deliveryLink = e.target.closest('.delivery-time a');
  if (!deliveryLink) return;

  e.preventDefault();

  if (window.Podium && typeof window.Podium.open === 'function') {
    window.Podium.open();
  } 
  else if (window.PodiumWebChat && typeof window.PodiumWebChat.open === 'function') {
    window.PodiumWebChat.open();
  }

});

function byor_image(){
  const byor = document.querySelector('#byor_diamond_preview');
  if (byor) {
    byor.classList.add('byor_diamond_preview_custom');
    // byor.removeAttribute('id');
  }
}

function cleanProductDesciption(){
    const el = document.querySelector('.metafield-multi_line_text_field');
  if (!el) return;

  el.innerHTML = el.innerHTML.replace(/:/g, '');
}

function openPop() {
  document.querySelectorAll('share-drawer').forEach(el => {
    el.classList.remove('hidden');
  });
  
    document.querySelectorAll('[data-toggle="modal"]').forEach(trigger => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-target');
        if (targetId) {
          const drawer = document.querySelector(targetId);
          if (drawer){
            drawer.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
          } 
        }
      });
    });

    // Close drawer on close button
    document.querySelectorAll('[data-drawer-close]').forEach(btn => {
      btn.addEventListener('click', function () {
        const drawer = this.closest('share-drawer');
        if (drawer) {
          drawer.classList.remove('is-visible');
          document.body.style.overflow = '';
        }
      });
    });

    // Close drawer on overlay click
    document.querySelectorAll('share-drawer').forEach(drawer => {
      const overlay = drawer.querySelector('.cart-drawer__overlay');
      if (overlay) {
        overlay.addEventListener('click', function () {
          drawer.classList.remove('is-visible');
          document.body.style.overflow = '';
        });
      }
    });
    
}

function showVaraintOption() {
  const jsonElement = document.getElementById(`ProductVariantJson`);
  if (!jsonElement) {
    console.error(`JSON data not found for product`);
    return;
  }

  const productVariants = JSON.parse(jsonElement.innerHTML);
  const radios = document.querySelectorAll('input[name^="options["]');
  const currencySymbol = "$";

  function getCurrentSelection() {
    const selection = {};
    document.querySelectorAll('input[name^="options["]:checked').forEach(input => {
      const name = input.name.match(/\[(.*?)\]/)[1];
      selection[name] = input.value;
    });
    return selection;
  }

  function findVariant(selection) {
    return productVariants.find(variant => {
      return Object.keys(selection).every(key => {
        return variant.options.includes(selection[key]);
      });
    });
  }

  // --- INITIAL STATE ---
  // Run this immediately to show names on page refresh
  const initialSelection = getCurrentSelection();
  Object.keys(initialSelection).forEach(key => {
    const handle = key.trim().toLowerCase().replace(/\s+/g, "-");
    const displayEl = document.getElementById(`selected-${handle}`);
    if (displayEl) {
      displayEl.textContent = initialSelection[key].replace('K','ct');
    }
  });

  radios.forEach(radio => {
    const optionName = radio.name.match(/\[(.*?)\]/)[1];
    const optionHandle = optionName.trim().toLowerCase().replace(/\s+/g, "-");
    
    const displayEl = document.getElementById(`selected-${optionHandle}`);
    const priceDiffEl = document.getElementById(`price-diff-${optionHandle}`);
    const label = document.querySelector(`label[for="${radio.id}"]`);

    if (!displayEl || !label) return;

    label.addEventListener("mouseenter", () => {
      displayEl.textContent = radio.value.replace('K','ct');
      const currentSelection = getCurrentSelection();
      const hypotheticalSelection = { ...currentSelection, [optionName]: radio.value };
      
      const currentVariant = findVariant(currentSelection);
      const hoveredVariant = findVariant(hypotheticalSelection);

      if (currentVariant && hoveredVariant && priceDiffEl) {
        const diff = hoveredVariant.price - currentVariant.price;
        if (diff !== 0) {
          const sign = diff > 0 ? "+" : "-";
          const formattedDiff = (Math.abs(diff) / 100).toFixed(0);
          priceDiffEl.textContent = `(${sign}${currencySymbol}${formattedDiff})`;
        } else {
          priceDiffEl.textContent = "";
        }
      }
    });

    label.addEventListener("mouseleave", () => {
      const current = getCurrentSelection();
      displayEl.textContent = current[optionName].replace('K','ct') || "";
      if (priceDiffEl) priceDiffEl.textContent = "";
    });

    radio.addEventListener("change", () => {
      const current = getCurrentSelection();
      displayEl.textContent = current[optionName].replace('K','ct');
      if (priceDiffEl) priceDiffEl.textContent = "";
    });
  });
}

function customBack(fallbackLink) {
  const referrer = document.referrer;

  // Check if referrer exists AND contains '/collections/'
  if (referrer && referrer.includes('/collections/')) {
    window.history.back();
  } else {
    // If they came from home, a blog, or directly, use the fallback
    window.location.href = fallbackLink;
  }
}

// function changeSKU() {
//   const sku = document.getElementById('variant_sku')?.value || '';
//   const skuBox = document.getElementById('sku_value');

//   if (skuBox) {
//     skuBox.textContent = sku;
//   }

//   const metal = document.getElementById('variant_metal')?.value || '';
//   const metalBox = document.getElementById('metal_value');

//   if (metalBox) {
//     metalBox.textContent = metal;
//   }
// }

// function selectInitialVariant() {

//   if (window.innerWidth >= 750) {
//     return;
//   }

//     const metalTypeInputs = document.querySelectorAll(
//         'input[name="options[Metal Type]"]'
//     );

//     if (metalTypeInputs.length === 0) {
//         return;
//     }

//     const urlParams = new URLSearchParams(window.location.search);
//     if (urlParams.has('variant')) {
//         return; 
//     }else{
//         const firstOption = metalTypeInputs[0];
//         const secondOption = metalTypeInputs[1];
//         if (firstOption && secondOption) {
//             secondOption.click();
//             firstOption.click();
//         }
//     }

//     const letterTypeInputs = document.querySelectorAll(
//         'input[name="options[Letter]"]'
//     );


//     if (letterTypeInputs.length === 0) {
//         return;
//     }else{
//         const firstOption = letterTypeInputs[0];
//         const secondOption = letterTypeInputs[1];
//         if (firstOption && secondOption) {
//             secondOption.click();
//             firstOption.click();
//         }
//     }
// }


// function updateImagesByMetal(e) {
//   const selectedMetal = e.target.value;

//   // Normalize metal text
//   const metal = selectedMetal
//     .trim()
//     .toLowerCase()
//     .replace(/\b(9|10|14|18)\s*k(t)?\b/gi, "")  // remove 9K, 10K, 14K, 18K
//     .replace(/[0-9]+/g, "")                  // remove leftover digits
//     .replace(/\s+/g, "");                   // spaces remove

//   const divs = document.querySelectorAll('.swiper-wrapper-window > div');
//   let visibleCount = 0;

//   divs.forEach(div => {
//     const alt = div.getAttribute('data-alt');

//     if (alt) {
//       const altList = alt.split(",").map(a => a.trim().toLowerCase());
//       if (altList.includes(metal)) {
//         div.style.display = "block";
//         visibleCount++;
//       } else {
//         div.style.display = "none";
//       }
//     }
//   });


//   const mob_divs_thumb = document.querySelectorAll('.swiper-thumbs .swiper-wrapper > div');
//   mob_divs_thumb.forEach(div => {
//     const alt = div.getAttribute('data-alt');


//     if (alt) {
//       const altList = alt.split(",").map(a => a.trim().toLowerCase());

//       if (altList.includes(metal)) {
//         //div.style.visibility = "";
//         div.style.display = "block";
//       } else {
//         //div.style.visibility = "hidden";
//         div.style.display = "none";
//       }
//     }
//   });
  
//   // If ALL alt divs are hidden → show all again
//   if (visibleCount === 0) {
//     divs.forEach(div => {
//       const alt = div.getAttribute('data-alt');
//       if (alt) {
//         div.style.display = "block";
//       }
//     });

//     mob_divs_thumb.forEach(div => {
//       const alt = div.getAttribute('data-alt');
//       if (alt) {
//         div.style.display = "block";
//         //div.style.visibility = "";
//       }
//     });

//   }

//  const element = document.querySelector('.swiper-thumbs-container .swiper-thumbs .swiper-wrapper');
//   if (element) {

//     if(document.querySelector('.swiper-slide .iframe-click-layer')){
//       visibleCount++;
//     }

//     if (visibleCount >= 4) {
//         element.classList.add('center-four-thumbs');
//         element.classList.remove('center-three-thumbs');
//     }
//     if (visibleCount <= 3) {
//         element.classList.add('center-three-thumbs');
//         element.classList.remove('center-four-thumbs');
//     }

//     if(visibleCount <= 5){
//       element.classList.add('center-five-thumbs');
//     }else{
//       element.classList.remove('center-five-thumbs');
//     }
//   }
// }

// function updateVideo() {
//   const videoEl = document.getElementById('video_360');
//   const videoFrame = document.getElementById('video_360_frame');
//   const videoFrameMob = document.getElementById('video_360_frame_mob');
//   const videoFrameThumb = document.getElementById('video_360_frame_thumb');

//   const selectedVideo = videoEl?.dataset.video || null;

//   // Update video src
//   if (selectedVideo) {
//     if (window.innerWidth < 750) {
//     // Mobile
//     videoFrameMob.src = selectedVideo;
//     videoFrameThumb.src = selectedVideo;
//     } else {
//     // Desktop + Thumbnail
//     videoFrame.src = selectedVideo;
//     }
//   }

//   const firstVisibleImg = Array.from(
//   document.querySelectorAll(".swiper-wrapper-window img")
//   ).find(img => img.offsetParent !== null);

//   const rect = firstVisibleImg.getBoundingClientRect();

//  if (firstVisibleImg && videoFrame) {
//   const applySize = () => {
//     videoFrame.style.width = rect.width + "px";
//     videoFrame.style.height = rect.height + "px";
//   };

//   if (firstVisibleImg.complete) {
//     applySize();
//   } else {
//     firstVisibleImg.onload = applySize;
//   }
//  }

// }
